import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import { grossProfitReportService } from "@/services/gross-profit-report";
import type { GrossProfitReportParams } from "@/services/gross-profit-report";

export type { GrossProfitReportParams };

export function useGrossProfitReport(params?: GrossProfitReportParams) {
  return useQuery({
    queryKey: queryKeys.grossProfitReport.get(
      params as Record<string, unknown>,
    ),
    queryFn: () => grossProfitReportService.get(params),
  });
}
